import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { FinancialReportEntity } from "domain/entity/FinancialReport/FinancialReportEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import reportAxiosInstance from "../axios/reportAxiosInstance";
import { FinancialReportRepository } from "./FinancialReportRepo";

export const FinancialReportRepoImpl = (): FinancialReportRepository => {


    const initFinancialReportList = async (): Promise<string[]> => {
        const searchUrl = "/v1/initFinancialReportList"
        return axiosGetData(reportAxiosInstance, `${searchUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const exportReport = async (entity: FinancialReportEntity): Promise<ResponseEntity> => {
        const exportUrl = "/v1/financialReportExport"
        return await axiosPostData(reportAxiosInstance, `${exportUrl}`, entity);
    }
    const downloadReport = async (entity: FinancialReportEntity): Promise<ResponseEntity> => {
        const downloadUrl = "/v1/financialReportDownload"
        return await axiosPostData(reportAxiosInstance, `${downloadUrl}`, entity);
    }

    const print = async (entity: FinancialReportEntity): Promise<ResponseEntity> => {
        const printUrl = "/v1/financialReportPrint"
        return await axiosPostData(reportAxiosInstance, `${printUrl}`, entity);
    }

    const view = async (entity: FinancialReportEntity): Promise<ResponseEntity> => {
        const viewUrl = "/v1/financialReportView"
        return await axiosPostData(reportAxiosInstance, `${viewUrl}`, entity);
    }

    const submit = async (entity: FinancialReportEntity): Promise<ResponseEntity> => {
        const exportUrl = "/v1/financialReportSubmit"
        return await axiosPostData(reportAxiosInstance, `${exportUrl}`, entity);
    }

    return {
        initFinancialReportList: initFinancialReportList,
        downloadReport: downloadReport,
        exportReport: exportReport,
        print: print,
        view: view,
        submit: submit
    }
}
